/** Shared Hotsites mark (product + footer badge). */
export const HOTSITES_LOGO_SRC = '/images/hotsites-logo.svg';
